<template>
    <div>
        <div class="header" id="header">
            <nav class="nav-bar">
                <div class="nav-content  w1200 clearfix">
                    <div class="fl nav-left">
                        <router-link class="font-color-white" to="/home">欢迎来到Mary少儿英语</router-link>
                    </div>
                    <div class="fr nav-left" v-if="isloginStatus"> <!--登录成功-->
                                              
                        <a href="javascript:void(0);" @click="gotoPersonalCenter(0)">个人中心</a>

                        <span class="font-color-999">{{decodeURIComponent(userInfo.nickName)}}</span>
                         &nbsp;&nbsp;
                        <a href="javascript:void(0);" @click="signOut()">退出</a>
                    </div>
                    <div class="fr nav-right"  v-else>
                        <a href="javascript:void(0);" @click="showLoginDialog">请登录</a>
                        
                    </div>
                </div>
                
            </nav>
            <header class="herder w1200 clearfix">
                <div class="header-left fl">
                    <div class="logo display-inline">
                        <router-link to="/home" class="clearfix">
                            <img src="./../../assets/images/logo.jpg" style="width: 240px;height: 64px" />
                        </router-link>
                    </div>
                    <div class="location-address display-inline" style="visibility:hidden;">
                        <i class="iconfont">&#xe634;</i>
                        <span class="city-name">北京市海淀区</span>
                    </div>
                </div>
                <div class="header-center fl">
                    <div class="search-wrap">
                        <input class="search-input" type="text" placeholder="请输入你想搜索的课程" v-model="keyWord" @keyup.enter="toCourse" name="搜索">
                        <a class="search-btn" href="javascript:void(0);"  @click="doSearchCourse()">搜索</a>
                    </div>
                </div>
                <div class="header-right fr">
                    <i class="iconfont icon-phone theme-font-color">&#xe882;</i>
                        <div class="hotline-Telephone">
                            <em class="font-size-18">咨询热线</em>
                            <div class="theme-font-color hotline-Telephone-num font-size-18">13701230113</div>
                        </div>
                    </div>
            </header>
            <div class="header-menu clearfix">
                <home-left-menu :leftIsShow="showIndex"></home-left-menu>
                <ul class="fl menu">
                    <li :class="{active:menuItem.isActive}" 
                        v-for="menuItem in menuList" :key="menuItem.index"
                         @click="gotoSubViewController(menuItem.path)">
                        <a href="javascript:void(0);">{{menuItem.name}}</a>
                    </li>
                </ul>
            </div>
        </div>

        <!--登录界面-->
        <div class="register model">
            <el-dialog title="登录"  :visible.sync="dialogFormLogin" :append-to-body="true">
                <el-form :model="loginForm" ref="loginForm" class="demo-ruleForm" >
                    <div class="register-form">
                        <el-form-item prop="phone" auto-complete="off">
                            <!-- <el-input  placeholder="请输入手机号" v-model="loginForm.phone"></el-input> -->
                            <el-input autofocus="autofocus" placeholder="请输入手机号" v-model="loginForm.phone"  @keyup.enter="submitForm('loginForm',0)">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <div class="verification-code clearfix">
                                <el-input class="fl" placeholder="请输入验证码" v-model="loginForm.verifyCode"></el-input>
                                <a href="javascript:void(0);"  @click="getVerfityCode">{{verfityText}}</a>
                            </div>
                        </el-form-item>
                        <el-button type="primary" @click="submitForm('loginForm',0)">立即登录</el-button>
                        <div class="colorRed pt5 visibilityShow" v-if="isError">{{errotmsg}}</div>
                    
                        <div class="register-btn">
                            <a href="javascript:void(0);" @click="gotoRegister">立即注册</a>

                            <!-- <a href="javascript:void(0);" @click="dialogFormRegister = true,isError == false">立即注册</a> -->
                        </div>
                    </div>
                </el-form>

            </el-dialog>
        </div>

        <!--注册界面-->
        <div class="register model">
            <el-dialog title="注册"  :visible.sync="dialogFormRegister" :append-to-body="true">
                <el-form :model="registeForm" :rules="registerRules" ref="registeForm" class="demo-ruleForm">
                    <div class="register-form">
                        <el-form-item prop="phone">
                            <el-input placeholder="请输入手机号" v-model="registeForm.phone" autofocus="autofocus"></el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <div class="verification-code clearfix">
                                <el-input class="fl" placeholder="请输入验证码" v-model="registeForm.verifyCode"></el-input>
                                <a href="javascript:void(0);" @click="getVerfityCode">{{verfityText}}</a>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('registeForm',1)">立即注册</el-button>
                            <div class="colorRed pt5 visibilityShow" v-if="isError">{{errotmsg}}</div>
                        </el-form-item>
                    </div>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import homeLeftMenu from './homeLeftMenu.vue'

export default {
    props:{
        showIndex:{
            type:Number,
            default:0
        },
    },
    components:{
        homeLeftMenu
        //homeRightFlag
    },
    data() {
        var checkPhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('手机号不能为空'));
            }else if(this.checkPhoneNum(value) == false){
                callback(new Error('手机号不合法'))
            }
            // callback();
        };
        var checkVerifyCode = (rule,value,callback) => {
            if(value === ''){
                callback(new Error('验证码不能为空'))
            }
            callback();
        };
        return {

            userInfo:[],
            timer:null,
            keyWord:'',//搜索内容
            isloginStatus:false,        //登录状态
            menuList:[
                {path:'/home',name:'首页',isActive:true},
                {path:'/courseList',name:'课程',isActive:false}
            ],
            isError:false,

            verfityText:'获取验证码',
            dialogFormLogin: false, 
            loginForm: {
                phone: '',
                pass:'',
                verifyCode:''
            },
            loginRules: {
                phone: [
                    { 
                        validator:checkPhone, 
                        trigger: 'blur' 
                    },
                ],
                pass: [
                    { 
                        validator:checkVerifyCode, 
                        trigger: 'blur' 
                    },
                ]
            },
            registerRules: {
                phone: [
                { validator:checkPhone, trigger: 'blur' },
                ],
               
                verifyCode: [
                { validator:checkVerifyCode, trigger: 'blur'}
                ]
            },
            dialogFormRegister:false,  //注册界面
            registeForm: {
                phone: '',
                pass: '',
                verifyCode:''
            },
        }
    },
    created(){
        if(localStorage.state==1){
            this.userInfo = JSON.parse(localStorage.userInfo);

            this.isloginStatus = true;
        }else{
            this.isloginStatus = false;
        }

        this.hightLightTab(this.showIndex)
    },
    methods:{
        gotoSubViewController: function (path){ //菜单跳转路由
            this.$router.push(path)
        },
        loginViewShow(){
            this.dialogFormLogin = true
        },
        doSearchCourse(){ //跳转到课程列表页
            this.$router.push({ name: 'courseList', params: {keyWord:this.keyWord,searchType:1001}}) //回车查询事件
            this.$emit('search',{keyWord:this.keyWord,searchType:1001}) //监听按钮点击事件
        },


        //显示登录界面
        showLoginDialog(){
            console.log("showLoginForm");
            this.dialogFormLogin = true
        },
        submitForm(formName,type) {
            this.$refs[formName].validate((valid) => {
                if(valid){
                    this.toLogin();
                }
            })
          console.log(formName +type);  
        },
         hightLightTab(index){ //菜单切换
            for(var i =0;i<this.menuList.length;i++){
                var menuModel = this.menuList[i]
                if(i == index){
                menuModel.isActive = true
                }else {
                menuModel.isActive = false
                }
            }
        },
        //用户登录
        toLogin(){
            this.$http.post(this.baseUrl()+'/mobile/user/loginByCode',
                this.$qs.stringify({
                    username:this.loginForm.phone,
                    verifycode: this.loginForm.verifyCode
                }),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((successResp) => {

                     if(successResp.body.flag == 1){
                        this.isError = false
                        localStorage.status = 1
                        localStorage.token = successResp.body.token
                        localStorage.userInfo = JSON.stringify(successResp.body.data)
                        this.userInfo = successResp.body.data
                        localStorage.userId = successResp.body.data.userId
                        localStorage.avatar = successResp.body.data.avatar
                        
                        this.dialogFormLogin = false
                        this.dialogFormRegister = false

                        this.isloginStatus = true

                        localStorage.state = 1;
                        console.log(successResp.body.data);
                        this.clearShow();
                     }else{
                        this.isError = true
                        this.errotmsg = successResp.body.msg
                        this.isloginStatus = true
                        return
                     }
            })
        },

        signOut(){ //退出
            var self = this;
            this.$confirm('确定要退出Mary少儿英语吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // this.$message({
                //   type: 'success',
                //   message: '删除成功!'
                // });
                this.messageNum = 0
                localStorage.status = 0
                localStorage.token = ''
                this.isloginStatus = false
                localStorage.clear();
                self.$router.push('/home'); //退出后返回首页
            }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });          
            });

            
        },
        //切换
        gotoRegister(){
            this.isRegister = true
            //this.dialogFormForgetPassword = false
            this.dialogFormLogin = false
            this.dialogFormRegister = true
            //this.clearShow()
        },
        //手机校验
        checkPhoneNum(phone){
            var length = phone.length
            if(length == 11 && /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1})|)+\d{8})$/.test(phone)){
                return true
            }else{
                return false
            }
        },
        // 获取验证码
        getVerfityCode(){
            if(this.dialogFormLogin == true){
                // console.log(this.registeForm.phone)
                if(this.loginForm.phone == ''){
                    this.refsWithforName('loginForm')
                    return
                }
                if(this.checkPhoneNum(this.loginForm.phone) == false){
                    return
                }

                this.$http.post(this.baseUrl()+'/mobile/user/code',
                        this.$qs.stringify({username:this.loginForm.phone}),
                        {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                        }).then((successResp) => {

                    if(successResp.body.flag == 1){
                         this.timedCount();
                         return;
                    }else{
                        this.$message({
                             message:successResp.body.msg,
                             type: 'warning'
                        });
                    }
                })
            }
        },
        clearShow(){
            // console.log(this.timer)
            clearInterval(this.timer)
            this.timer = null
            this.verfityText = '获取验证码'
            this.isError = false
        },
         // 计时器
        timedCount() {
            // this.verfityText = '我点击了一下'
            // 变灰  倒计时
            var intDiff = 60
            // var timer = null
            var self = this
            clearInterval(this.timer)
            this.timer = setInterval(function(){
                if(intDiff == 0){
                    // 变蓝 
                    self.verfityText = '获取验证码'
                    // intDiff = 60
                    clearInterval(self.timer)
                return
                }
                // console.log('zezefamily')
                intDiff--
                
                self.verfityText = '已发送'+'('+intDiff+')'

            },1000)
        },
        refsWithforName (formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        
        toCourse(){ //跳转到课程列表页
            // console.log(this.keyWord)
            this.$router.push({ name:'courseList', params: {keyWord:this.keyWord,searchType:1001}}) //回车查询事件
            this.$emit('search',{keyWord:this.keyWord,searchType:1001}) //监听按钮点击事件
        },

        //进入我的课程
        gotoPersonalCenter(index){
            if(index == 0){
                localStorage.centerIndex =0
                this.$router.push({ path: '/personalCenter/myCourse'});
                this.$emit('reloadPersonal')
            }else if(index == 4){
                localStorage.centerIndex =4
                this.$router.push({ path: '/personalCenter/myOrder' });
                this.$emit('reloadPersonal')
            }
        }
    }
}
</script>
<style scoped="scoped">
    .nav-bar{
        background-color: #393d48;
    }
    .nav-bar .nav-content{
        margin:0 auto;
    }
    .nav-bar .nav-content .nav-left a{
        color: #999;
        border-right: 1px solid #999;
        display: inline-block;
        padding-right: 19px;
        margin:10px 17px 11px 0;
    }
    .nav-bar .nav-content .nav-left a:last-child{
        border-right: none;
    }
    .nav-content .nav-right{
        margin-top: 10px;
    }
    .nav-content .nav-right a{
        color: #999;
        display: inline-block;
        text-align: center;
    }
    .nav-content .nav-right a:last-child{
        margin-left: 36px;
    }

    #header{
        border-bottom: 4px solid #f49d40; 
    }
    .herder{
        margin: 0 auto;
        background-color: #fff;
        padding: 19px 0 8px;
    }
    .header-left .logo{
            width:198px;
        /*height: 54px;*/
        margin-right: 40px;
        vertical-align:middle;
        color: #333;
    }
    .header-left .logo .logoImg{
        width: 56px;
        height: 55px;
        margin-right: 9px;
    }
    .header-left .logo .logoImg >img{
        width: 100%;
    }
    .header-left .logo .logoText h1{
        font-size: 26px;
    }
    .header-left .logo .logoText span{
        font-size: 12px;
    }
    .header-left .location-address{
        vertical-align: middle;
    }
    .header-left .location-address .city-name{
        width: 85px;
        line-height: 15px;
        display: inline-block;
        text-overflow:ellipsis;
        overflow:hidden;
        white-space: nowrap;
    }
    .header-center{
        /*margin-left:60px;*/
        margin-left: 70px;
    }
    .header-center .search-wrap{
        position: relative;
        margin-top:5px;
        width: 438px;
        height: 40px;
    }
    .header-center .search-wrap .search-input{
        position: absolute;
        top: 0;
        left: 0;
        width:358px;
        padding:9px 8px 8px;
        font-size: 14px;
        border:2px solid #ccc;
        border-right: none;
    }
    .header-center .search-wrap .search-btn{
        position: absolute;
        top: 0;
        right: 0;
        width: 80px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        background-color: #f49d40;
        font-size: 16px;
    }
    .header-center .search-tag{
        margin-top:9px; 
    }
    .header-center .search-tag a{
        color: #999;
        margin-right: 25px;
    }
    .header-right .icon-phone{
        font-size: 38px;
        display: inline-block;
        margin-right: 14px;
    }
    .header-right .hotline-Telephone{
        display: inline-block;
    }
    .header-right .hotline-Telephone-num{
        font-weight: bold;
    }

    .model .el-dialog__wrapper .el-dialog.el-dialog--small{
        width: 400px;
    }
    .model .el-dialog__header{
        text-align: center;
        font-weight: normal;
        background-color: #f7f7f7;
        padding: 23px 10px;
        border-bottom: 1px solid #dfdfdf;
    }
    .model .el-dialog__title{
        font-weight: normal;
        color: #333;
        font-size: 16px;
    }
    
    .model .el-input-group__append{
        background-color: #00ced1;
        color: #fff;
        border-color: #00ced1;
        cursor: pointer;
    }
    .model .el-dialog__header{
        text-align: center;
        font-weight: normal;
        background-color: #f7f7f7;
        padding: 23px 10px;
        border-bottom: 1px solid #dfdfdf;
    }
    .model .el-dialog__title{
        font-weight: normal;
        color: #333;
        font-size: 16px;
    }
    .model .el-input__inner{
        border-radius: 0;
    }
    .model .el-input__inner:hover,
    .model .el-input__inner:focus{
    /*border-color: #00ced1;*/
        border-color: #f49d40;
        border-radius: 0;
    }
    .model .el-button--primary{
        /*
        background-color: #00ced1;
        border-color: #00ced1;
        */
        /*background-color: #f49d40;
        border-color: #f49d40;*/
        width: 100%;
        border-radius: 0;
        position: relative;
    }
    .model .el-button--primary:focus:before,
    .model .el-button--primary:hover:before{
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 10;
        background: rgba(0,0,0,.1);
    }
    

    .register-form{
        padding:30px 55px 24px;
    }
    .register .go-login,.forgetPassword .go-login{
        font-size: 12px;
        color: #999;
        text-align: right;
        margin-top: 10px;
    }
    .register .go-login a,.forgetPassword .go-login a{
        /*color: #00ced1;*/
        color: #f49d40;
        font-size: 14px;
    }
    .register .el-dialog__headerbtn,
    .forgetPassword .el-dialog__headerbtn{
        margin-top:-17px;
    }
    .register .el-dialog__close,
    .forgetPassword .el-dialog__close{
        font-size: 12px;
    }

    .register .verification-code.disableCord a,
    .forgetPassword .verification-code.disableCord a{
        background: #dfdfdf;
        color: #999;
        border-color: #dfdfdf;
    }
    .verification-code .el-input{
        width: 60%;
    }
    .verification-code a{
        display: inline-block;
        /*background: #00ced1;*/
        background-color: #f49d40;
        color: #fff;
        width: 40%;
        text-align: center;
        padding:0;
    }
</style>